import React from "react";
import { Box } from "../../../components/styled/Elements";
import Header from "../../../components/landingSections/header/Header";
import Banner from "../../../components/landingSections/banner/Banner";
import HowItWorks from "../../../components/landingSections/howItWorks/HowItWorks";
import WhyFalBio from "../../../components/landingSections/whyFalbio/WhyFalBio";
import Faqs from "../../../components/landingSections/faqs/Faqs";
import Footer from "../../../components/landingSections/footer/Footer";
import { faqThirdData, howItWorksSecData, whyFalData } from "../../../components/data/data";
import Contact from "../../../components/landingSections/contact/Contact";

const LandingPage = () => {

  return (
    <Box bg="var(--white)">
      <Header btnLabel="sign_up" btnUrl="/signup" />
      <Banner />
      <WhyFalBio data={whyFalData} />
      <HowItWorks title="how_to_create_your_profile" data={howItWorksSecData} />
      <Faqs data={faqThirdData} />
      <Contact />
      <Footer />
    </Box>
  );
};

export default LandingPage;
